import React, { useState } from "react";

const NavIcons = ({ href, icon, hoverIcon }) => {
  const [isHovered, setIsHovered] = useState(false);
  return (
    <a
      href={href}
      className="p-2 text-2xl bg-transparent"
      //   style={{ lineHeight: "3.5rem", verticalAlign: "middle" }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {isHovered ? hoverIcon : icon}
    </a>
  );
};

export default NavIcons;
